import { makeStyles } from "tss-react/mui"
import { useFormikContext } from "formik"
import { Box, Grid, Typography } from "@mui/material"
import { DisplayLabelType, OfferDetailsFormValues } from "../../productsTypes"
import { LocalizedEnum, LocalizedStrict } from "../../../../../localization/components/AppLocalized"

const useStyles = makeStyles()((theme) => ({
    container: {
        display: "grid",
        gap: "1rem",
    },
    title: {
        color: theme.palette.tailwind.slate[600],
    },
    tagCard: {
        padding: "1.25rem 0.75rem",
        border: `2px solid ${theme.palette.tailwind.gray[300]}`,
        borderRadius: "0.25rem",
        cursor: "pointer",
        transition: "border-color 0.3s",
        "&:hover": {
            borderColor: theme.palette.tailwind.green[500],
        },
    },
    tagCardSelected: {
        borderColor: theme.palette.tailwind.green[600],
    },
    circle: {
        padding: "1rem",
        width: "5rem",
        height: "5rem",
        borderRadius: "50%",
        backgroundColor: "black",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "white",
        textAlign: "center",
        margin: "0 auto",
    },
    tagText: {
        fontWeight: 500,
        lineHeight: 1.5,
    },
    box: {
        height: "5rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "0.5rem",
    },
    boxPrice: {
        color: "red",
        fontWeight: "bold",
    },
    boxOldPrice: {
        color: theme.palette.tailwind.gray[300],
        textDecoration: "line-through",
    },
}))

export const MarketingTags = () => {
    const { values, setFieldValue } = useFormikContext<OfferDetailsFormValues>()
    const tags = Object.values(DisplayLabelType)
    const { classes, cx } = useStyles()

    return (
        <Box className={classes.container}>
            <LocalizedStrict id="product-create-offer-dialog-marketing-tag-label">
                <Typography variant="subtitle1" fontWeight={500} className={classes.title}>
                    Marketing tag:
                </Typography>
            </LocalizedStrict>
            <Grid container spacing={2}>
                {tags.map((tag) => (
                    <Grid item key={tag} xs={4}>
                        <Box
                            className={cx(classes.tagCard, {
                                [classes.tagCardSelected]: values.discount.displayLabelType === tag,
                            })}
                            onClick={() => setFieldValue("discount.displayLabelType", tag)}
                        >
                            {tag !== DisplayLabelType.OLD_NEW_PRICE ? (
                                <Box className={classes.circle}>
                                    <LocalizedEnum
                                        base="product-create-offer-dialog-marketing-tag-mode"
                                        enumValue={tag}
                                    >
                                        <Typography variant="caption" className={classes.tagText}>
                                            {tag}
                                        </Typography>
                                    </LocalizedEnum>
                                </Box>
                            ) : (
                                <Box className={classes.box}>
                                    <LocalizedStrict id="product-create-offer-dialog-marketing-tag-mode-old-new-price-new">
                                        <Typography variant="caption" className={classes.boxPrice}>
                                            25,00 kr
                                        </Typography>
                                    </LocalizedStrict>
                                    <LocalizedStrict id="product-create-offer-dialog-marketing-tag-mode-old-new-price-old">
                                        <Typography variant="caption" className={classes.boxOldPrice}>
                                            35,00 kr
                                        </Typography>
                                    </LocalizedStrict>
                                </Box>
                            )}
                        </Box>
                    </Grid>
                ))}
            </Grid>
        </Box>
    )
}
